// extracted by mini-css-extract-plugin
module.exports = {"header":"b429494557--header--yAjyL","heading":"b429494557--heading--vW1tv"};